export default "__VITE_ASSET__CqTMc41D__"